






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
// @ts-ignore
import { VueMathjax } from 'vue-mathjax';

@Component({
    name: 'Glossary',
    components: {
        'vue-mathjax': VueMathjax,
    },
})
export default class Glossary extends Vue {
    protected get isCustomer() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.CustomerRelations
        );
    }

    protected get isTrademark() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Trademark
        );
    }

    protected get isGoodwill() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Goodwill
        );
    }

    protected get isTechnology() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Technology
        );
    }

    protected get isSoftware() {
        return (
            this.$store.getters['user/activeProductGroup'] ===
            ProductGroupTypes.Software
        );
    }

    protected get glossaryTitle() {
        return this.getAppropriatePhrase(
            'Glossary trademarks – explanations and definitions',
            'Glossary customer relations – explanations and definitions',
            'Glossary goodwill – explanations and definitions',
            'Glossary technology – explanations and definitions',
            'Glossary software – explanations and definitions',
        );
    }

    protected getAppropriatePhrase(
        trademarkPhrase: string,
        customerPhrase: string,
        goodwillPhrase: string,
        technologyPhrase: string,
        softwarePhrase: string,
    ) {
        if (this.isTrademark) {
            return trademarkPhrase;
        }

        if (this.isCustomer) {
            return customerPhrase;
        }

        if (this.isGoodwill) {
            return goodwillPhrase;
        }

        if (this.isTechnology) {
            return technologyPhrase;
        }

        return softwarePhrase;
    }
}
